import { ModalHeader } from '@scaleaq/scaleui';
import { useTranslation } from 'react-i18next';

import { StyledModal } from '@/styles.ts';
import { ModalControllerType } from '@/types.ts';

import { ChartModalContent } from './chartModal/ChartModalContent.tsx';
import { PlotType } from './types.ts';

type ChartDialogProps = {
  rootId?: string;
  widgetId?: string;
  modalController: ModalControllerType;
  plotType?: PlotType;
};

// This only works with charts that are widgets in a layout. In other cases, use the PlotType-specific configs
export const ChartModal = ({ widgetId, modalController, plotType, rootId }: ChartDialogProps) => {
  const { t } = useTranslation(['chartConfig']);
  const { open, onClose } = modalController;

  return (
    <StyledModal open={open} onClose={onClose}>
      <ModalHeader title={t('chartConfigModal.title')} onClose={onClose} />
      <ChartModalContent
        plotType={plotType}
        widgetId={widgetId}
        onSave={onClose}
        onClose={onClose}
        rootId={rootId}
      />
    </StyledModal>
  );
};
